import YDescriptions from './src'

YDescriptions.install = Vue => {
  Vue.component(YDescriptions.name, YDescriptions)
}

export default YDescriptions
